import { useEffect, useState } from 'react';
import { ISelect } from '../../../../../../shared/types/shared';
import { useFormik } from 'formik';
import { Account } from '../../../../../../shared/types/modules/account';

export const useAccountDetailGeneralInfo = (account?: Account) => {
    const [typesPerson, setTypesPerson] = useState<ISelect[]>([]);
    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);
    const [cities, setCities] = useState<ISelect[]>([]);
    const [typeContactPersons, setTypeContactPersons] = useState<ISelect[]>([]);
    const [genders, setGenders] = useState<ISelect[]>([]);

    const formik = useFormik({
        initialValues: {
            document: '',
            personType: '',
            typeDocument: '',
            name: '',
            lastName: '',
            gender: '',
            isLGBTIQ: false,
            cellPhone: '',
            phone: '',
            email: '',
            city: '',
            address: '',
            typeContactPerson: '',
        } as Account & {
            city?: string;
            address?: string;
            typeContactPerson?: string;
        },
        onSubmit: console.log,
    });

    const changeData = async (account?: Account) => {
        if (account?.personType)
            setTypesPerson([account.personType as ISelect]);
        if (account?.typeDocument)
            setTypesDocument([account.typeDocument as ISelect]);
        if (account?.address?.city)
            setCities([account.address?.city as ISelect]);
        if (account?.contactType?.typeContactPerson)
            setTypeContactPersons([
                account?.contactType?.typeContactPerson as ISelect,
            ]);
        if (account?.gender) setGenders([account.gender as ISelect]);

        formik.setValues({
            ...formik.values,
            document: account?.document || '',
            personType: (account?.personType as ISelect)?.id.toString() || '',
            typeDocument:
                (account?.typeDocument as ISelect)?.id.toString() || '',
            gender: (account?.gender as ISelect)?.id.toString() || '',
            name: `${account?.name} ${account?.lastName}` || '',
            cellPhone: account?.cellPhone || '',
            phone: account?.phone || '',
            email: account?.email || '',
            city: (account?.address?.city as ISelect)?.id.toString() || '',
            address: (account?.address?.address || '') as any,
            typeContactPerson:
                (
                    account?.contactType?.typeContactPerson as ISelect
                )?.id.toString() || '',
        });
    };

    useEffect(() => {
        changeData(account);
    }, [account]);

    return {
        formik,
        typesPerson,
        typesDocument,
        cities,
        typeContactPersons,
        genders,
    };
};
